import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { decryptData } from "src/utils/decryptcookie";
import LoadingScreen from "../../../components/LoadingScreen.js";
import AuthGuard from "../../../guards/AuthGuard.js";
import DashboardLayout from "../../../layouts/dashboard/index.js";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            }),
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

const UserProfile = Loadable(
  lazy(() => import("src/pages/dashboard/UserProfile.js"))
);

const SubAgentList = Loadable(
  lazy(() => import("src/pages/AgentPortal/table/SubAgentList.js"))
);

const SubAgentProfile = Loadable(
  lazy(() => import("src/pages/AgentPortal/SubAgentProfile.js"))
);

const BookingTablePage = Loadable(
  lazy(() => import("src/pages/Bookings/BookingTablePage"))
);

const BookingsHistory = Loadable(
  lazy(() => import("src/pages/Bookings/userBookings"))
);
const TransactionPage = Loadable(
  lazy(() => import("src/pages/AccountsDepartment/TransactionPage"))
);

const AgentToCheckRules = Loadable(
  lazy(() =>
    import("src/components/_dashboard/adminPages/AdminFareRuleChooseAgent.js")
  )
);
const FlightInvoiceBreakdownPage = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/common/FlightInvoiceBreakdownPage.jsx"))
);
const BulkData = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/Bulkdata.js"))
);
const ScrappyUser = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/AddScrappyUser.js"))
);
const ViewScrappyUser = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/ViewScappyUser.js"))
);
const GetMeta = Loadable(lazy(() => import("src/pages/Meta-mange.js")));
const AppliedRule = Loadable(
  lazy(() => import("src/pages/FareRule/ExistingFareRule.js"))
);
const ViewAllData = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/ViewData.js"))
);
const AddIternary = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/AddIternary.js"))
);

// const CreateBooking = Loadable(lazy(() => import("../../pages/BookingApi")));
const Cancellations = Loadable(
  lazy(() => import("src/pages/cancellations.js"))
);

const AgentInfoTable = Loadable(
  lazy(() =>
    import("src/pages/RelationshipManager/AgentSection/AgentInfoTable.js")
  )
);
const SettlementCyclePage = Loadable(
  lazy(() =>
    import("src/pages/dashboard/SettlementCyclePage.js")
  )
);

const Alltransaction = Loadable(
  lazy(() => import("src/pages/PaymentRequests/AgentTransactions.js"))
);

const ViewAgentInfo = Loadable(
  lazy(() =>
    import("src/pages/RelationshipManager/AgentSection/ViewAgentInfo.js")
  )
);

export const AccountsRoutes = () => {
  const parsedData = decryptData("_b60-g6fr_plus");

  return {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),

    children: [
      {
        path: "",
        element: (
          // <Navigate
          //   to={
          //     parsedData === null
          //       ? "/dashboard"
          //       : parsedData?.role === "admin"
          //       ? "/dashboard/manager-info"
          //       : parsedData?.role === "manager"
          //       ? "/dashboard/agent-info"
          //       : parsedData?.role === "agent"
          //       ? "/dashboard/sub-agent-info"
          //       : parsedData?.role === "sub-agent"
          //       ? "/dashboard/bookingsHistory"
          //       : parsedData?.role
          //   }
          //   replace
          // />
          <Navigate to={"/dashboard/add-info"} replace />
        ),
      },

      // tables 
      { path: "settle-cycle", element: <SettlementCyclePage /> },
      { path: "flight-invoice-breakdown", element: <FlightInvoiceBreakdownPage /> },
      { path: "user-profile", element: <UserProfile /> },
      // partner
      { path: "add-info", element: <AgentInfoTable /> },
      { path: "alltransaction", element: <Alltransaction /> },
      { path: "agent-info", element: <ViewAgentInfo /> },
      { path: "sub-agent-info/:id", element: <SubAgentList /> },
      { path: "sub-agent-profile", element: <SubAgentProfile /> },
      // { path: "flight_booking", element: <FlightBooking /> },

      // { path: "resultoneway", element: <Resultoneway /> },
      // { path: "resulttwoway", element: <Resulttwoway /> },
      // { path: "farerule", element: <FareRule /> },
      // { path: "applyrule", element: <ApplyRule /> },
      // { path: "trans", element: <Transaction /> },
      // { path: "topup", element: <Topup /> },
      { path: "AppliedRule", element: <AppliedRule /> },
      { path: "bookingsHistory", element: <BookingsHistory /> },
      // { path: "approval", element: <Approval /> },
      // { path: "alltransaction", element: <Alltransaction /> },
      // { path: "chooseAgent", element: <ChooseAgent /> },
      // { path: "agentLedger", element: <AgentLedger /> },
      { path: "cancellations", element: <Cancellations /> },
      { path: "checkAgentRules", element: <AgentToCheckRules /> },
      { path: "scrap-all-data", element: <ViewAllData /> },
      { path: "add-Iternary", element: <AddIternary /> },
      { path: "add-bulk-data", element: <BulkData /> },
      { path: "add-scrappy-user", element: <ScrappyUser /> },
      { path: "view-scrappy-user", element: <ViewScrappyUser /> },
      { path: "get-meta", element: <GetMeta /> },
      { path: "accounts-all-requests", element: <TransactionPage /> },
      { path: "all-booking-details", element: <BookingTablePage /> },
      // { path: "", element: <BookingTablePage /> },
      // { path: "agent-info", element: <AgentInfoTable /> },
      // { path: "add-agent-info", element: <AddAgents /> },
      // { path: "edit-agent-info", element: <EditAgentInfo /> },
      // { path: "agent-info", element: <ViewAgentInfo /> },
      // { path: "agent-wallet", element: <AgentWallet /> },
      // { path: "manager-info", element: <ManagerTable /> },
      // { path: "all-requests", element: <AllRequest /> },
      // { path: "edit-manager-info", element: <EditManagerInfo /> },
      // { path: "sub-agent-info", element: <SubAgentTable /> },
      // { path: "add-sub-agent-info", element: <AddAgentInfo /> },
      // { path: "edit-sub-agent-info", element: <EditSubAgent /> },
      // { path: "sub-agent-profile", element: <SubAgentProfile /> },
      // { path: "sub-agent-wallet", element: <SubAgentWallet /> },
      // {
      //   path: "add-manager-info",
      //   element: <AddManager />,
      // },
      // {
      //   path: "manager-profile",
      //   element: <ManagerProfilePage />,
      // },

      // {
      //   path: "user",
      //   children: [
      //     {
      //       path: "",
      //       element: <Navigate to="/dashboard/user/profile" replace />,
      //     },
      //     { path: "profile", element: <UserProfile /> },
      //     { path: "cards", element: <UserCards /> },
      //     { path: "list", element: <UserList /> },
      //     { path: "new", element: <UserCreate /> },
      //     { path: "product/:name/edit", element: <UserCreate /> },
      //     { path: "account", element: <UserAccount /> },
      //   ],
      // },
      // {
      //   path: "blog",
      //   children: [
      //     {
      //       path: "",
      //       element: <Navigate to="/dashboard/blog/posts" replace />,
      //     },
      //     { path: "posts", element: <BlogPosts /> },
      //     { path: "post/:title", element: <BlogPost /> },
      //     { path: "new-post", element: <BlogNewPost /> },
      //   ],
      // },
      // {
      //   path: "mail",
      //   children: [
      //     {
      //       path: "",
      //       element: <Navigate to="/dashboard/mail/all" replace />,
      //     },
      //     { path: "label/:customLabel", element: <Mail /> },
      //     { path: "label/:customLabel/:mailId", element: <Mail /> },
      //     { path: ":systemLabel", element: <Mail /> },
      //     { path: ":systemLabel/:mailId", element: <Mail /> },
      //   ],
      // },
      // {
      //   path: "chat",
      //   children: [
      //     { path: "", element: <Chat /> },
      //     { path: "new", element: <Chat /> },
      //     { path: ":conversationKey", element: <Chat /> },
      //   ],
      // },
      // { path: "calendar", element: <Calendar /> },
      // { path: "kanban", element: <Kanban /> },
    ],
  };
};
